import api from "lib/axios";
import type { ApiEnvelope, PaginatedResult } from "services/apiTypes";
import { unwrapList } from "services/apiTypes";

export type GuestStage = { id: number; name: string; slug: string };
export type GuestGrade = { id: number; name: string; stage_id: number };

type ListQuery = {
  page?: number;
  limit?: number;
  term?: string;
  stage_id?: number;
  "filter[stage_id]"?: number;
};

export const guestAcademicService = {
  async listStages(params: ListQuery = {}) {
    const res = await api.get<ApiEnvelope<PaginatedResult<GuestStage>>>(
      "/guest/stages",
      { params, meta: { toastSuccess: false } }
    );
    return unwrapList<GuestStage>(res.data);
  },
  async listGrades(params: ListQuery = {}) {
    const res = await api.get<ApiEnvelope<PaginatedResult<GuestGrade>>>(
      "/guest/grades",
      { params, meta: { toastSuccess: false } }
    );
    return unwrapList<GuestGrade>(res.data);
  },
};
